module.exports = __webpack_public_path__ + "img/transform_txt.fa041a26.svg";